import { Modal } from 'antd';

interface ComfirmDialogProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  title: string;
  confirmBtnText: string;
  isDanger?: boolean;
}

const ComfirmDialog = ({
  open,
  onOk,
  onCancel,
  title,
  confirmBtnText,
  isDanger = false,
}: ComfirmDialogProps) => {
  return (
    <Modal
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      cancelText="取消"
      okText={confirmBtnText}
      okButtonProps={{
        danger: isDanger,
      }}
      width={300}
    >
      <div style={{ padding: '10px 0' }}>{title}</div>
    </Modal>
  );
};

export default ComfirmDialog;
